export const InvoiceStatusKeys = {
  PENDING: 'pending',
  PAID: 'paid',
};



// WEBPACK FOOTER //
// ./src/domain/invoice.js